<div class="admin-posts">

  <!-- Page header -->
  <div class="page-header">
    <div class="page-header__text">
      <h1 class="page-title">Posts</h1>
      <p class="page-subtitle">Moderate sales listings and accommodation posts</p>
    </div>
    <div class="page-header__actions">
      <button mat-stroked-button class="btn-secondary" (click)="openCreateSale()" [disabled]="creatingSale">
        <mat-icon>storefront</mat-icon>
        New sale
      </button>
      <button mat-flat-button class="btn-primary" (click)="openCreateAccommodation()" [disabled]="creatingAccommodation">
        <mat-icon>add_home</mat-icon>
        New accommodation
      </button>
    </div>
  </div>

  <!-- Filters -->
  <div class="filters-bar">
    <mat-form-field appearance="outline" class="filter-field filter-field--search">
      <mat-label>Search</mat-label>
      <mat-icon matPrefix class="filter-prefix-icon">search</mat-icon>
      <input matInput [formControl]="searchControl" placeholder="Item name or description…" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>State code</mat-label>
      <input matInput [formControl]="stateCodeControl" placeholder="e.g. LA" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>State</mat-label>
      <mat-select [formControl]="stateControl">
        <mat-option value="">All states</mat-option>
        <mat-option *ngFor="let state of stateOptions" [value]="state.id">{{ state.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>LGA</mat-label>
      <mat-select [formControl]="lgaControl" [disabled]="!stateControl.value">
        <mat-option value="">All LGAs</mat-option>
        <mat-option *ngFor="let lga of lgaOptions" [value]="lga.id">{{ lga.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Deleted posts</mat-label>
      <mat-select [formControl]="deletedControl">
        <mat-option value="hide">Hide</mat-option>
        <mat-option value="include">Show them too</mat-option>
        <mat-option value="only">Only deleted</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Tabs -->
  <mat-tab-group [(selectedIndex)]="selectedTabIndex" class="posts-tabs">

    <!-- Sales tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        <span>Sales</span>
        <span class="tab-badge" *ngIf="!loading && sales.length > 0">{{ sales.length }}</span>
      </ng-template>

      <div class="tab-panel">
        <!-- Loading -->
        <div *ngIf="loading" class="state-placeholder">
          <mat-icon class="state-placeholder__icon">hourglass_empty</mat-icon>
          <span>Loading posts…</span>
        </div>

        <!-- Empty -->
        <div *ngIf="!loading && sales.length === 0" class="state-placeholder">
          <mat-icon class="state-placeholder__icon">storefront</mat-icon>
          <span>No sale posts found</span>
        </div>

        <!-- List -->
        <div *ngIf="!loading && sales.length > 0" class="post-list">
          <div class="post-row" *ngFor="let sale of sales">
            <ng-container *ngIf="getPostMedia(sale) as saleMedia">

              <!-- Thumbnail -->
              <div class="post-thumb">
                <img
                  *ngIf="saleMedia.length; else noSaleMedia"
                  [ngSrc]="saleMedia[0].url"
                  fill
                  [alt]="saleMedia[0].alt_text ?? sale.item_name ?? 'Sale image'"
                  (error)="handleImageError($event)"
                  class="post-thumb__img"
                />
                <ng-template #noSaleMedia>
                  <div class="post-thumb__empty">
                    <mat-icon>image_not_supported</mat-icon>
                  </div>
                </ng-template>
              </div>

              <!-- Info -->
              <div class="post-info">
                <div class="post-info__header">
                  <span class="post-title">{{ sale.item_name }}</span>
                  <span class="post-id-badge">ID {{ sale.id }}</span>
                </div>
                <div *ngIf="sale.deleted_at" class="post-deleted-badge">
                  Deleted by its poster {{ sale.deleted_at | date: 'mediumDate' }} · gone for good {{ purgeDate(sale) | date: 'mediumDate' }}
                </div>
                <div class="post-price">
                  ₦{{ sale._price ?? sale.price }}
                  <span class="post-price__min" *ngIf="sale.minimum_price || sale._minimum_price">
                    &nbsp;· min ₦{{ sale._minimum_price ?? sale.minimum_price }}
                  </span>
                </div>
                <div class="post-meta-row">
                  <span class="post-meta-item">
                    <mat-icon>location_on</mat-icon>
                    {{ sale?.Location?.address ?? sale?.Location?.state ?? sale.state ?? 'No location' }}
                  </span>
                  <span class="post-meta-item" *ngIf="saleMedia.length">
                    <mat-icon>photo_library</mat-icon>
                    {{ saleMedia.length }} image{{ saleMedia.length > 1 ? 's' : '' }}
                  </span>
                  <span class="post-meta-item">
                    <mat-icon>schedule</mat-icon>
                    {{ sale._age ?? sale.created_at ?? 'Unknown date' }}
                  </span>
                </div>
                <p class="post-excerpt" *ngIf="sale.text">{{ sale.text }}</p>
              </div>

              <!-- Actions -->
              <div class="post-actions">
                <button mat-stroked-button class="btn-view" (click)="openPostDetails(sale, 'sale')">
                  View details
                </button>
                <button mat-icon-button class="btn-delete" (click)="deleteSale(sale)" [matTooltip]="sale.deleted_at ? 'Remove for good now' : 'Delete post'">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>

            </ng-container>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Accommodations tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        <span>Accommodations</span>
        <span class="tab-badge" *ngIf="!loading && accommodations.length > 0">{{ accommodations.length }}</span>
      </ng-template>

      <div class="tab-panel">
        <!-- Loading -->
        <div *ngIf="loading" class="state-placeholder">
          <mat-icon class="state-placeholder__icon">hourglass_empty</mat-icon>
          <span>Loading posts…</span>
        </div>

        <!-- Empty -->
        <div *ngIf="!loading && accommodations.length === 0" class="state-placeholder">
          <mat-icon class="state-placeholder__icon">home_work</mat-icon>
          <span>No accommodation posts found</span>
        </div>

        <!-- List -->
        <div *ngIf="!loading && accommodations.length > 0" class="post-list">
          <div class="post-row" *ngFor="let acc of accommodations">
            <ng-container *ngIf="getPostMedia(acc) as accMedia">

              <!-- Thumbnail -->
              <div class="post-thumb">
                <img
                  *ngIf="accMedia.length; else noAccMedia"
                  [ngSrc]="accMedia[0].url"
                  fill
                  [alt]="accMedia[0].alt_text ?? acc.accommodation_type ?? 'Accommodation image'"
                  (error)="handleImageError($event)"
                  class="post-thumb__img"
                />
                <ng-template #noAccMedia>
                  <div class="post-thumb__empty">
                    <mat-icon>image_not_supported</mat-icon>
                  </div>
                </ng-template>
              </div>

              <!-- Info -->
              <div class="post-info">
                <div class="post-info__header">
                  <span class="post-title">{{ acc.accommodation_type }}</span>
                  <span class="post-id-badge">ID {{ acc.id }}</span>
                </div>
                <div *ngIf="acc.deleted_at" class="post-deleted-badge">
                  Deleted by its poster {{ acc.deleted_at | date: 'mediumDate' }} · gone for good {{ purgeDate(acc) | date: 'mediumDate' }}
                </div>
                <div class="post-price">
                  ₦{{ acc._rent ?? acc.rent }}
                  <span class="post-price__min" *ngIf="acc.rent_interval">&nbsp;/ {{ acc.rent_interval }}</span>
                </div>
                <div class="post-meta-row">
                  <span class="post-meta-item">
                    <mat-icon>location_on</mat-icon>
                    {{ acc?.Location?.address ?? acc?.Location?.state ?? acc.state ?? 'No location' }}
                  </span>
                  <span class="post-meta-item" *ngIf="accMedia.length">
                    <mat-icon>photo_library</mat-icon>
                    {{ accMedia.length }} image{{ accMedia.length > 1 ? 's' : '' }}
                  </span>
                  <span class="post-meta-item">
                    <mat-icon>schedule</mat-icon>
                    {{ acc._age ?? acc.created_at ?? 'Unknown date' }}
                  </span>
                </div>
                <div class="post-status" *ngIf="acc._status ?? acc.status">
                  <span class="status-chip" [class.status-chip--available]="(acc._status ?? acc.status) === 'available'">
                    {{ acc._status ?? acc.status }}
                  </span>
                </div>
              </div>

              <!-- Actions -->
              <div class="post-actions">
                <button mat-stroked-button class="btn-view" (click)="openPostDetails(acc, 'accommodation')">
                  View details
                </button>
                <button mat-icon-button class="btn-delete" (click)="deleteAccommodation(acc)" [matTooltip]="acc.deleted_at ? 'Remove for good now' : 'Delete post'">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>

            </ng-container>
          </div>
        </div>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>
